/**
 * Events API Module
 * Handles pop-up events (public + admin)
 */

import { api } from './client'

export const eventsAPI = {
  // Public
  getActiveEvents: () => api.get('/events'),
  getEvent: (id) => api.get(`/events/${id}`),

  // Admin
  adminListEvents: (params) => api.get('/admin/events', { params }),
  adminGetEvent: (id) => api.get(`/admin/events/${id}`),
  adminCreateEvent: (data) => api.post('/admin/events', data),
  adminUpdateEvent: (id, data) => api.put(`/admin/events/${id}`, data),
  adminDeleteEvent: (id) => api.delete(`/admin/events/${id}`),
  adminPublishEvent: (id) => api.put(`/admin/events/${id}/publish`),
  adminUnpublishEvent: (id) => api.put(`/admin/events/${id}/unpublish`),
  adminActivateEvent: (id) => api.post(`/admin/events/${id}/activate`),
  adminDeactivateEvent: (id) => api.post(`/admin/events/${id}/deactivate`),
  adminBulkPublishEvents: () => api.post('/admin/events/bulk-publish'),
  adminAddParticipant: (eventId, data) => api.post(`/admin/events/${eventId}/participants`, data),
  adminRemoveParticipant: (eventId, entityId) =>
    api.delete(`/admin/events/${eventId}/participants/${entityId}`),

  // Entity search (for participant lookup — uses existing admin entities endpoint)
  searchEntities: (query) =>
    api.get('/admin/entities', { params: { search: query, limit: 20, page: 1 } }),
}
